import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { tokens } from '../onboarding';

interface Props {
  /** Titre du visa demandé, ou null quand le dialogue est fermé. */
  titreVisa: string | null;
  onClose: () => void;
}

/**
 * Affiché quand le visa cliqué vise une route qu'App.tsx ne déclare pas.
 * Sans ce filet, l'utilisateur atterrissait sur une page blanche — et,
 * s'il n'avait pas encore de voyageur, seulement APRÈS avoir rempli tout le
 * profil voyageur, documents compris.
 */
const DestinationIndisponibleDialog: React.FC<Props> = ({ titreVisa, onClose }) => {
  const theme = useTheme();
  const plein = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={titreVisa !== null}
      onClose={onClose}
      fullScreen={plein}
      maxWidth="xs"
      fullWidth
      aria-labelledby="destination-indisponible-titre"
    >
      <DialogTitle id="destination-indisponible-titre" sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: '50%',
              backgroundColor: '#e8f5e9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <SupportAgentIcon sx={{ color: tokens.VERT }} />
          </Box>
          <Typography component="span" sx={{ fontWeight: 700, fontSize: '1.1rem', lineHeight: 1.3 }}>
            Demande à monter avec un conseiller
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.65 }}>
          {titreVisa ? `« ${titreVisa} » ne se demande pas encore en ligne. ` : ''}
          Un conseiller constitue le dossier avec vous et vous transmet la liste exacte des
          pièces à fournir. Écrivez-nous en précisant votre destination et votre date de départ.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none', color: '#888' }}>
          Retour
        </Button>
        <Button
          variant="contained"
          href="mailto:contact@visamonde.com"
          onClick={onClose}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: tokens.RAYON,
            background: tokens.GRADIENT_VERT,
            boxShadow: tokens.OMBRE_BOUTON,
            '&:hover': { background: tokens.GRADIENT_VERT_HOVER, boxShadow: tokens.OMBRE_BOUTON_HOVER },
          }}
        >
          Contacter un conseiller
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DestinationIndisponibleDialog;
